import { fromJS } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import { CLEAR_PROJECT } from '../PlanSelection/constants'
import * as actionTypes from './constants'

const initialState = fromJS({})

function searchReducer(state = initialState, action) {
  let helperVariable

  switch (action.type) {
    case actionTypes.GET_RECENT_SEARCH_REQUESTS:
      if (typeof window.localStorage !== 'undefined') {
        // needed for test
        helperVariable = window.localStorage.getItem(
          `${action.userId}:recentSearchRequests`
        )

        if (helperVariable) {
          return state
            .set('recentSearchRequests', JSON.parse(helperVariable))
            .set('userId', action.userId)
        }
        window.localStorage.setItem(
          `${action.userId}:recentSearchRequests`,
          JSON.stringify([])
        )
      }
      return state.set('recentSearchRequests', []).set('userId', action.userId)
    case actionTypes.ADD_RECENT_SEARCH_REQUEST:
      if (action.search !== state.get('recentSearchRequests')[0]) {
        helperVariable = [
          action.search,
          ...state.get('recentSearchRequests')
        ].slice(0, 20)

        if (typeof window.localStorage !== 'undefined') {
          // needed for test
          window.localStorage.setItem(
            `${state.get('userId')}:recentSearchRequests`,
            JSON.stringify(helperVariable)
          )
        }
        return state.set('recentSearchRequests', helperVariable)
      }
      return state
    case actionTypes.CLEAR_RECENT_SEARCH_REQUESTS:
      if (typeof window.localStorage !== 'undefined') {
        // needed for test
        window.localStorage.setItem(
          `${state.get('userId')}:recentSearchRequests`,
          JSON.stringify([])
        )
      }
      return state.set('recentSearchRequests', [])

    case actionTypes.SEARCH_GENERIC_DATASETS:
    case actionTypes.SEARCH_GENERIC_PINS:
    case actionTypes.SEARCH_GENERIC_GROUPS:
    case actionTypes.SEARCH_GENERIC_TASKS:
    case actionTypes.SEARCH_GENERIC_PLANS:
    case actionTypes.SEARCH_GENERIC_REPORTS:
      return state
        .set(`searching${action.place}`, true)
        .set(`search${action.place}Error`, null)
    case actionTypes.SEARCH_GENERIC_DONE:
      return state
        .set(`searching${action.place}`, false)
        .set(action.place, action.results)
    case actionTypes.SEARCH_GENERIC_ERROR:
      return state
        .set(`searching${action.place}`, false)
        .set(`search${action.place}Error`, action.error)

    case actionTypes.SEARCH_TEAM_MEMBERS:
      return state
        .set('searchingTeamMembers', true)
        .set('searchTeamMembersError', null)
    case actionTypes.SEARCH_TEAM_MEMBERS_DONE:
      return state
        .set('searchingTeamMembers', false)
        .set('teamMembers', action.results)
    case actionTypes.SEARCH_TEAM_MEMBERS_ERROR:
      return state
        .set('searchingTeamMembers', false)
        .set('searchTeamMembersError', action.error)

    case actionTypes.OPEN_PROJECTS:
      return state.set('projectsOpen', true)
    case actionTypes.CLOSE_PROJECTS:
      return state.set('projectsOpen', false).set('projectFilter', '')
    case actionTypes.OPEN_PROJECT_FOLDER:
      return state.set('projectFolders', action.folders)
    case actionTypes.SET_PROJECT_FILTER:
      return state.set('projectFilter', action.filter)
    case CLEAR_PROJECT:
      return state.set('projectFolders', '').set('projectFilter', '')

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default searchReducer
